const OBJECT_ID_RE = /^[0-9a-fA-F]{24}$/;

export function isValidObjectId(value: unknown): value is string {
  return typeof value === 'string' && OBJECT_ID_RE.test(value);
}

export function generateClientId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function ensureQuizOptionIds(options: unknown[]): Array<{ id: string; [key: string]: string }> {
  return (options || []).map((raw, optIdx) => {
    if (!raw || typeof raw !== 'object') {
      return { id: generateClientId(`opt-${optIdx}`) };
    }
    const opt = raw as { id?: string; _id?: string; [key: string]: string | undefined };
    const stableId = opt.id || opt._id?.toString?.() || generateClientId(`opt-${optIdx}`);
    return { ...opt, id: String(stableId) };
  });
}

/**
 * Garantit des ids stables pour l'éditeur admin (questions + options).
 * Les questions utilisent `id` côté UI, mappé depuis `_id` Mongo au chargement.
 */
export function ensureQuizQuestionIds(item: any): any {
  if (!item || item.itemType !== 'quiz') return item;
  return {
    ...item,
    questions: (item.questions || []).map((q: any, qIdx: number) => ({
      ...q,
      id: q.id
        ? String(q.id)
        : q._id
          ? String(q._id)
          : generateClientId(`q-${qIdx}`),
      options: ensureQuizOptionIds(q.options || []),
    })),
  };
}

/** Prépare un quiz pour la sauvegarde backend (map id → _id, conserve option.id). */
export function serializeQuizItemForBackend(item: any): any {
  if (!item || item.itemType !== 'quiz') return item;

  return {
    ...item,
    questions: (item.questions || []).map((q: any, qIdx: number) => {
      const questionId = q._id || (q.id && isValidObjectId(q.id) ? q.id : undefined);
      const { id: _clientId, ...rest } = q;
      return {
        ...rest,
        ...(questionId ? { _id: questionId } : {}),
        order: q.order ?? qIdx + 1,
        options: ensureQuizOptionIds(q.options || []),
      };
    }),
  };
}

export function serializeChaptersQuizItemsForBackend(chapters: any[]): any[] {
  return (chapters || []).map((chapter) => ({
    ...chapter,
    items: (chapter.items || []).map((item: any) => serializeQuizItemForBackend(item)),
  }));
}
